import * as PropTypes from 'prop-types';
import * as React from 'react';

const Sorting = ({ sort, indexParams }) => (
  <div className="pull-right-tablet-up filter-margined-left">
    <div className="inline-block">
      <div className="products-view-switch wide-mobile">
        <form onSubmit={(e) => { e.preventDefault(); }}>
          <div className="styled-dropdown">
            <select
              name="sort"
              id="sort"
              value={sort || ''}
              onChange={(e) => { indexParams.changeSort(e); }}
            >
              <option value="most_recent">{I18n.t('digitalProductsIndex.updatedAt')}</option>
              <option value="popularity">{I18n.t('digitalProductsIndex.popularity')}</option>
              <option value="name">{I18n.t('digitalProductsIndex.name')}</option>
              <option value="price|asc">{I18n.t('digitalProductsIndex.priceAsc')}</option>
              <option value="price|desc">{I18n.t('digitalProductsIndex.priceDesc')}</option>
            </select>
          </div>
        </form>
      </div>
    </div>
  </div>
);

Sorting.propTypes = {
  sort: PropTypes.string,
  indexParams: PropTypes.object.isRequired,
};

export default Sorting;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/sorting.jsx